import { render, staticRenderFns } from "./holiday-config.vue?vue&type=template&id=ec5ba042&scoped=true"
import script from "./holiday-config.vue?vue&type=script&lang=js"
export * from "./holiday-config.vue?vue&type=script&lang=js"
import style0 from "./holiday-config.vue?vue&type=style&index=0&id=ec5ba042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ba042",
  null
  
)

export default component.exports